import "core-js/modules/es.array.concat.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "container"
  }, [_c('a-card', {
    staticClass: "search-card",
    attrs: {
      "title": "筛选",
      "size": "small"
    }
  }, [_c('div', {
    class: _vm.expand ? 'search' : null
  }, [_c('a-form-model', {
    ref: "searchFrom",
    attrs: {
      "model": _vm.where,
      "label-col": _vm.labelCol,
      "wrapper-col": _vm.wrapperCol
    }
  }, [_c('div', {
    class: _vm.expand ? null : 'fold'
  }, [_c('a-row', [_c('a-col', {
    attrs: {
      "span": 8
    }
  }, [_c('a-form-model-item', {
    style: {
      marginBottom: '5px'
    },
    attrs: {
      "label": "紧急状态",
      "prop": "emergency"
    }
  }, [_c('a-select', {
    attrs: {
      "placeholder": "请选择紧急状态"
    },
    model: {
      value: _vm.where.emergency,
      callback: function callback($$v) {
        _vm.$set(_vm.where, "emergency", $$v);
      },
      expression: "where.emergency"
    }
  }, [_c('a-select-option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("全部")]), _c('a-select-option', {
    attrs: {
      "value": 1
    }
  }, [_vm._v("常规")]), _c('a-select-option', {
    attrs: {
      "value": 2
    }
  }, [_vm._v("紧急")]), _c('a-select-option', {
    attrs: {
      "value": 3
    }
  }, [_vm._v("重要")])], 1)], 1)], 1), _c('a-col', {
    attrs: {
      "span": 8
    }
  }, [_c('a-form-model-item', {
    style: {
      marginBottom: '5px'
    },
    attrs: {
      "label": "公告分类",
      "prop": "cateId"
    }
  }, [_c('a-select', {
    attrs: {
      "placeholder": "请选择公告分类"
    },
    model: {
      value: _vm.where.cateId,
      callback: function callback($$v) {
        _vm.$set(_vm.where, "cateId", $$v);
      },
      expression: "where.cateId"
    }
  }, [_c('a-select-option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("全部")]), _vm._l(_vm.cateList, function (item, index) {
    return _c('a-select-option', {
      key: index,
      attrs: {
        "value": item.cateId
      }
    }, [_vm._v(" " + _vm._s(item.cateName) + " ")]);
  })], 2)], 1)], 1), _c('a-col', {
    attrs: {
      "span": 8
    }
  }, [_c('a-form-model-item', {
    style: {
      marginBottom: '5px'
    },
    attrs: {
      "prop": "title",
      "label": "公告标题"
    }
  }, [_c('a-input', {
    directives: [{
      name: "emoji",
      rawName: "v-emoji"
    }],
    attrs: {
      "placeholder": "请输入公告标题"
    },
    model: {
      value: _vm.where.title,
      callback: function callback($$v) {
        _vm.$set(_vm.where, "title", $$v);
      },
      expression: "where.title"
    }
  })], 1)], 1)], 1)], 1), _c('span', {
    staticClass: "search-button"
  }, [_c('a-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function click($event) {
        return _vm.fetch({
          current: 1,
          pageSize: 10
        });
      }
    }
  }, [_vm._v("查询")]), _c('a-button', {
    staticClass: "reset",
    on: {
      "click": function click($event) {
        return _vm.$refs.searchFrom.resetFields();
      }
    }
  }, [_vm._v("重置")])], 1)])], 1)]), _c('a-card', {
    attrs: {
      "title": "列表",
      "size": "small",
      "bordered": false
    }
  }, [_c('a-table', {
    staticClass: "table-card-view",
    attrs: {
      "size": "middle",
      "row-key": function rowKey(row, index) {
        return row.id + "".concat(index);
      },
      "columns": _vm.columns,
      "pagination": _vm.pagination,
      "loading": _vm.loading,
      "data-source": _vm.data,
      "bordered": "",
      "scroll": {
        y: 500
      }
    },
    on: {
      "change": _vm.onChange
    },
    scopedSlots: _vm._u([{
      key: "drafterTemp",
      fn: function fn(text, row) {
        return [_c('div', {
          staticClass: "text-ellipsis",
          attrs: {
            "title": "".concat(row.releaseUser, "(").concat(row.organName, "/").concat(row.postName, ")")
          }
        }, [_vm._v(" " + _vm._s(row.releaseUser) + " (" + _vm._s(row.organName) + " / " + _vm._s(row.postName) + ") ")])];
      }
    }, {
      key: "emergency",
      fn: function fn(text, row) {
        return [1 === row.emergency ? _c('a-tag', {
          staticClass: "tag-blue"
        }, [_vm._v("常规")]) : _vm._e(), 2 === row.emergency ? _c('a-tag', {
          staticClass: "tag-red"
        }, [_vm._v("紧急")]) : _vm._e(), 3 === row.emergency ? _c('a-tag', {
          staticClass: "tag-green"
        }, [_vm._v("重要")]) : _vm._e()];
      }
    }, {
      key: "status",
      fn: function fn(text, row) {
        return [row.status === null ? _c('a-tag', {
          staticClass: "tag-dark-blue"
        }, [_vm._v("待反馈")]) : _vm._e(), row.status === 0 ? _c('a-tag', {
          staticClass: "tag-blue"
        }, [_vm._v("待审核")]) : _vm._e(), row.status === 1 ? _c('a-tag', {
          staticClass: "tag-shallow-orange"
        }, [_vm._v("审核中")]) : _vm._e(), row.status === 2 ? _c('a-tag', {
          staticClass: "tag-green"
        }, [_vm._v("通　过")]) : _vm._e(), row.status === 3 ? _c('a-tag', {
          staticClass: "tag-red"
        }, [_vm._v("不通过")]) : _vm._e(), row.status === 4 ? _c('a-tag', {
          staticClass: "tag-orange"
        }, [_vm._v("驳　回")]) : _vm._e()];
      }
    }, {
      key: "action",
      fn: function fn(text, row) {
        return [_c('a-dropdown', {
          attrs: {
            "trigger": ['click']
          }
        }, [_c('a', {
          staticClass: "ant-dropdown-link",
          on: {
            "click": function click(e) {
              return e.preventDefault();
            }
          }
        }, [_vm._v(" 操作"), _c('a-icon', {
          attrs: {
            "type": "down"
          }
        })], 1), _c('a-menu', {
          attrs: {
            "slot": "overlay"
          },
          slot: "overlay"
        }, [_c('a-menu-item', [_c('a-button', {
          attrs: {
            "type": "link"
          },
          on: {
            "click": function click($event) {
              return _vm.view(row);
            }
          }
        }, [_vm._v("查看")])], 1), row.status === null ? _c('a-menu-item', [_c('a-button', {
          attrs: {
            "type": "link"
          },
          on: {
            "click": function click($event) {
              return _vm.feedback(row);
            }
          }
        }, [_vm._v(" 反馈 ")])], 1) : _vm._e(), row.status === 4 ? _c('a-menu-item', [_c('a-button', {
          attrs: {
            "type": "link"
          },
          on: {
            "click": function click($event) {
              return _vm.feedback(row);
            }
          }
        }, [_vm._v(" 编辑 ")])], 1) : _vm._e()], 1)], 1)];
      }
    }])
  })], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };